<template>
  <div style="border: 1px solid #cccccc">
    <!-- 搜索框 -->
    <el-amap-search-box
      ref="searchBox"
      :search-option="searchOption"
      :on-search-result="onSearchResult"
      class="map-search"
    />

    <!-- 地图 -->
    <el-amap
      class="amap-box"
      ref="map"
      :zoom="amap.zoom"
      :center="amap.center"
      :events="amap.events"
      :plugin="amap.plugin"
    >
      <el-amap-marker
        v-for="(marker, index) in amap.markers"
        :key="'marker' + index"
        :position="marker.position"
      />
      <el-amap-text
        v-for="(marker, index) in amap.markers"
        :key="'text' + index"
        :text="marker.text"
        :offset="[0, 30]"
        :position="marker.position"
      />
    </el-amap>
  </div>
</template>

<script>
// 初始数据
function getFormData() {
  return {
    lat: '39.909186',
    lon: '116.39746',
    orgAddr: '天安门',
    province: '',
    city: '',
    district: ''
  }
}

export default {
  name: 'Map',
  data() {
    const vm = this
    return {
      dataForm: getFormData(),
      searchOption: {
        city: '',
        citylimit: false
      },
      amap: {
        zoom: 16,
        center: [],
        events: {
          click(e) {
            const { lng, lat } = e.lnglat
            vm.dataForm.lon = lng
            vm.dataForm.lat = lat
            vm.mapClick(lng, lat)
          }
        },
        plugin: [
          {
            pName: 'Geolocation',
            events: {
              init(o) {
                o.getCurrentPosition((status, result) => {
                  if (result && result.position) {
                    const lng = result.position.lng
                    const lat = result.position.lat
                    vm.amap.center = [lng, lat]
                    const op = {
                      position: [lng, lat],
                      text: result.formattedAddress
                    }
                    vm.amap.markers.push(op)
                  }
                })
              }
            }
          }
        ],
        markers: []
      }
    }
  },
  created() {
    this.initCenter()
  },
  methods: {
    // 地图点击
    mapClick(lng, lat) {
      const vm = this
      const geocoder = new AMap.Geocoder({ radius: 100, extensions: 'all' })
      geocoder.getAddress([lng, lat], (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          const ad = result.regeocode.addressComponent
          vm.dataForm.orgAddr = result.regeocode.formattedAddress
          vm.dataForm.province = ad.province
          vm.dataForm.city = ad.city || ad.province
          vm.dataForm.district = ad.district
          vm.dataForm.lat = lat + ''
          vm.dataForm.lon = lng + ''

          vm.amap.markers = [{
            position: [lng, lat],
            text: vm.dataForm.orgAddr
          }]
          vm.$emit('updateLocationMap', vm.dataForm)
        }
      })
    },

    // 初始化中心点
    initCenter() {
      this.amap.center = [116.39746, 39.909186]
    },

    // 给父组件调用的方法（兼容旧代码）
    initMarker(lng, lat, city, orgAddr) {
      const vm = this
      vm.amap.markers = []
      if (orgAddr) {
        vm.amap.markers.push({
          position: [lng, lat],
          text: orgAddr
        })
      }
      vm.amap.center = [lng, lat]
      vm.dataForm.city = city
      vm.dataForm.orgAddr = orgAddr
      vm.initSearchValue(orgAddr)
    },

    // 初始化搜索框值
    initSearchValue(address) {
      const vm = this
      if (vm.$refs.searchBox) {
        vm.$refs.searchBox.keyword = address
      }
    },

    // 清空地图标记和搜索框（用于新增时重置）
    clearMarker() {
      const vm = this
      // 清空标记
      vm.amap.markers = []
      // 重置中心点
      vm.amap.center = [116.39746, 39.909186]
      vm.amap.zoom = 16
      // 清空数据
      vm.dataForm = getFormData()
      // 清空搜索框
      if (vm.$refs.searchBox) {
        vm.$refs.searchBox.keyword = ''
      }
    },

    // 搜索回调（已修复：搜索什么显示什么）
    onSearchResult(pois) {
      if (!pois.length) return
      const vm = this
      const poi = pois[0]

      // 获取用户真正输入的原文（关键修复）
      let userInputAddr = ''
      if (vm.$refs.searchBox && vm.$refs.searchBox.$el) {
        const inputEl = vm.$refs.searchBox.$el.querySelector('input')
        if (inputEl) {
          userInputAddr = inputEl.value.trim()
        }
      }

      // 逆地理解析省市区
      const geocoder = new AMap.Geocoder({ radius: 1000, extensions: 'all' })
      geocoder.getAddress([poi.lng, poi.lat], (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          const ad = result.regeocode.addressComponent

          // 地址 = 用户输入的文字（不会变成医院名）
          vm.dataForm.orgAddr = userInputAddr || poi.address || poi.name
          vm.dataForm.province = ad.province
          vm.dataForm.city = ad.city || ad.province
          vm.dataForm.district = ad.district
          vm.dataForm.lon = String(poi.lng)
          vm.dataForm.lat = String(poi.lat)

          // 地图标记显示用户输入地址
          vm.amap.markers = [{
            position: [poi.lng, poi.lat],
            text: vm.dataForm.orgAddr
          }]
          vm.amap.center = [poi.lng, poi.lat]

          vm.$emit('updateLocationMap', vm.dataForm)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.amap-box {
  height: 420px;
}
.map-search {
  width: 100% !important;
}
</style>
